const listItemDefaultStyle = function (theme) {
  let selectable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    display: 'flex',
    '.ids-list-item-content': {
      width: '100%',
      padding: '8px 16px',
      borderStyle: 'solid',
      borderColor: `${theme.tokens.ComponentListItemBorderColor}`,
      borderWidth: '1px',
      backgroundColor: `${theme.tokens.ComponentListItemBg}`,
      ...(selectable ? {
        '&:hover': {
          backgroundColor: `${theme.tokens.ComponentListItemHoverColor}`
        }
      } : {})
    },
    ...(selectable ? {
      cursor: 'pointer',
      '&.ids-list-group-item-selected': {
        '.ids-list-item-content': {
          backgroundColor: `${theme.tokens.ComponentListItemHoverColor}`,
          paddingLeft: `calc(16px - 3px)`,
          borderLeft: 'none'
        },
        '.ids-list-item-content-selected': {
          borderLeftStyle: 'solid',
          borderLeftColor: `${theme.tokens.ComponentListItemSelectedColor}`,
          borderLeftWidth: '4px'
        }
      }
    } : {})
  };
};
export default listItemDefaultStyle;